<template>
  <div class="define_module">
    <div>
      <el-row :gutter='15'>
        <el-col :span="2">
          <div class="ctl_arrow">
            <div class="el-icon-arrow-left ctl_arrow_item" @click="goProduct(1)"></div>
          </div>
        </el-col>
        <el-col :span="5" v-for="(product,index) in playArr" :key="index">
          <div class="show_list_img" @click="viewProduct(product.pid)">
            <img :src="product.path" alt="" width="100%" height="222" class="definobj_img">
          </div>
        </el-col>
        <el-col :span="2">
          <div class="ctl_arrow">
            <div class="el-icon-arrow-right ctl_arrow_item" @click="goProduct(2)"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="product_divider">
      <el-divider></el-divider>
    </div>
    <div class="one_machine">
      <el-row>
        <el-col :span="6">
          <div>
            <div class="mainTitle">性能参数</div>
            <div>
              <img :src="defineInfo.paramsSrc" alt="" width="100%" height="100%">
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="product_cup">
            <div class="mainTitle">{{defineInfo.defineTitle}}</div>
            <div class="pro_main_pic">
              <img :src="defineInfo.showPicSrc" alt="" width="70%" height="90%">
            </div>
            <div class="ql-container ql-snow">
              <div v-html="defineInfo.defineText" class="ql-editor"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { oneProductInfo, productList } from '@/api/frontApi/product';
export default {
  props: {
    productId: String
  },
  data() {
    return {
      defineObjArr: [
        { path: '../../../../static/img/product/vehicle-1.png', index: 1 },
        { path: '../../../../static/img/product/vehicle-2.png', index: 2 },
        { path: '../../../../static/img/product/vehicle-3.png', index: 3 },
        { path: '../../../../static/img/product/vehicle-4.png', index: 4 },
        { path: '../../../../static/img/product/vehicle-5.png', index: 5 },
        { path: '../../../../static/img/product/vehicle-6.png', index: 6 },
        { path: '../../../../static/img/product/vehicle-7.png', index: 7 },
        { path: '../../../../static/img/product/vehicle-8.png', index: 8 }
      ],
      defineInfo: {
        defineText: '',
        paramsSrc: '',
        defineId: 0,
        showPicSrc: '',
        defineTitle: ''
      },
      playArr: []
    };
  },
  created() {
    this.defineObjList();
  },
  methods: {
    defineObjList() {
      productList(0).then(res => {
        if (res.data.length > 0) {
          this.defineObjArr = [];
          res.data.forEach(item => {
            let tempObj = { path: '', pid: 0, name: '' };
            tempObj.name = item.proTitle;
            tempObj.path = item.picMain;
            tempObj.pid = item.proId;
            this.defineObjArr.push(tempObj);
          });
          this.playArr = this.defineObjArr.slice(0, 4);
          if (this.productId) {
            this.viewProduct(this.productId);
          } else {
            this.viewProduct(this.defineObjArr[0].pid);
          }
        }
      });
    },
    viewProduct(defineId) {
      if (defineId) {
        oneProductInfo(parseInt(defineId)).then(res => {
          this.defineInfo.defineText = res.data.proBody;
          this.defineInfo.paramsSrc = res.data.picPara;
          this.defineInfo.showPicSrc = res.data.picMain;
          this.defineInfo.defineId = res.data.proId;
          this.defineInfo.defineTitle = res.data.proTitle;
        });
      }
    },
    goProduct(type) {
      switch (type) {
        case 1:
          this.playArr = this.back(this.playArr);
          break;
        case 2:
          this.playArr = this.forward(this.playArr);
          break;
      }
    },
    forward(arrayObj3) {
      let tempLen = arrayObj3.length;
      if (
        arrayObj3[tempLen - 1].pid ===
        this.defineObjArr[this.defineObjArr.length - 1].pid
      ) {
        arrayObj3.shift();
        arrayObj3.push(this.defineObjArr[0]);
      } else {
        for (let q = 0; q < this.defineObjArr.length; q++) {
          if (arrayObj3[tempLen - 1].pid === this.defineObjArr[q].pid) {
            arrayObj3.shift();
            arrayObj3.push(this.defineObjArr[q + 1]);
            break;
          }
        }
      }
      return arrayObj3;
    },
    back(arrayObj4) {
      let tempLen = arrayObj4.length;
      let tempObj = arrayObj4[tempLen - 1];
      if (arrayObj4[0].pid === this.defineObjArr[0].pid) {
        arrayObj4.pop();
        arrayObj4.unshift(this.defineObjArr[tempLen]);
      } else {
        for (let q = 0; q < this.defineObjArr.length; q++) {
          if (tempObj.pid === this.defineObjArr[q].pid) {
            arrayObj4.pop();
            if (q === this.defineObjArr.length - 1) {
              arrayObj4.unshift(this.defineObjArr[0]);
            } else {
              arrayObj4.unshift(this.defineObjArr[q + 1]);
            }
            break;
          }
        }
      }
      return arrayObj4;
    }
  }
};
</script>
<style lang="stylus" scoped>
.define_module {
  width 100%
  background-color #fff
  .product_divider {
    padding 0 10px
  }
  .one_machine {
    min-height 500px
    background-color #fff
    padding-left 40px
  }
}
.show_list_img {
  cursor pointer
  .definobj_img {
    border 1px solid #EBEEF5
  }
}
.product_cup {
  width 100%
  padding 0 15px
  .pro_main_pic {
    width 100%
    text-align center
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/defineObj.vue